import React, {useState} from 'react'
import { axiosWithAuth } from './axiosWithAuth'


const initial = {
    address:'',
    city:'',
    state:'',
    organizer_id: localStorage.getItem('organizer_id')
}
// const error = {
//     address:'',
//     city:'',
//     state:''
// }


const Location = () => {
    const [form,setForm] = useState(initial)
    

    const handleC = (event) => {
        event.preventDefault()
        const {name, value} = event.target
        setForm({...form, [name]:value})
    };

    const Submit = (event) => {
        event.preventDefault()
        const local = {
            location: form.location,
            city: form.city,
            state: form.state,
            organizer_id: localStorage.getItem('organizer_id')
        }
        postLocal(local);
        setForm(initial);
        
    } 

    const postLocal = (local) => {
        axiosWithAuth()
        // .post(`/events/${localStorage.getItem(organizer_id)}/location`)/*Might need {useParams} */

    }

    return (
        <div>
            <form onSubmit={Submit}>
                <label>
                    Address:
                <input
                    name = 'address'
                    type = 'text'
                    value = {form.address}
                    onChange = {handleC}
                />
                </label>
                <label>
                    City:
                <input
                    name = 'city'
                    type = 'text'
                    value = {form.city}
                    onChange = {handleC}
                />
                </label>
                <label>
                State:
                <input
                    name = 'state'
                    type = 'text'
                    value = {form.state}
                    onChange = {handleC}
                />
                </label>
            </form>
        </div>
    )
}

export default Location